export enum MimeType {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  WEBP = 'image/webp',
  MP4 = 'video/mp4',
  WEBM = 'video/webm',
  OGV = 'video/ogg',
  MP3 = 'audio/mpeg',
  OGG = 'audio/ogg',
  WAV = 'audio/wav',
  PLAIN = 'text/plain',
  HTML = 'text/html',
  PDF = 'application/pdf',
  ZIP = 'application/zip',
  JSON = 'application/json',
  CSV_TEXT = 'text/csv',
  CSV_APPLICATION = 'application/csv',
  CSV_MS_EXCEL = 'application/vnd.ms-excel',
  CSV_TEXT_X = 'text/x-csv',
  CSV_APPLICATION_X = 'application/x-csv',
  INI = 'text/ini',
  ALL = '*/*',
}

export const fileExtensions: { [key in MimeType]: string[] } = {
  [MimeType.JPEG]: ['.jpg', '.jpeg'],
  [MimeType.PNG]: ['.png'],
  [MimeType.GIF]: ['.gif'],
  [MimeType.WEBP]: ['.webp'],
  [MimeType.MP4]: ['.mp4'],
  [MimeType.WEBM]: ['.webm'],
  [MimeType.OGV]: ['.ogv'],
  [MimeType.MP3]: ['.mp3'],
  [MimeType.OGG]: ['.ogg', '.oga'],
  [MimeType.WAV]: ['.wav'],
  [MimeType.PLAIN]: ['.txt'],
  [MimeType.HTML]: ['.html', '.htm'],
  [MimeType.PDF]: ['.pdf'],
  [MimeType.ZIP]: ['.zip'],
  [MimeType.JSON]: ['.json'],
  [MimeType.CSV_TEXT]: ['.csv'],
  [MimeType.CSV_APPLICATION]: ['.csv'],
  [MimeType.CSV_MS_EXCEL]: ['.csv'],
  [MimeType.CSV_TEXT_X]: ['.csv'],
  [MimeType.CSV_APPLICATION_X]: ['.csv'],
  [MimeType.INI]: ['.ini'],
  [MimeType.ALL]: [],
};
